import React, { useEffect, useState } from "react";
import { makeStyles, TextField, Button } from "@material-ui/core";
import Switch from "@mui/material/Switch";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { moduleIdURL } from "../../../http/config";
import { requests } from "../../../requests";
import InputAdornment from "@mui/material/InputAdornment";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Backdrop } from "@material-ui/core";
import { StyledCircularProgress } from "../../../styles/StyledComponents";
import { StopScroll } from "../../../Regex";

const classes = {
  container: {
    width: "100%",
    height: "auto",
  },
  form: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: "15px",
  },
  formGroup: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "15px 0",
  },
  textField: {
    width: "40%",
  },
  formActions: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "15px 0",
  },
};

const EditForm = ({
  getFn,
  id,
  brokenPercentage,
  status,
  closePopup,
  isPopup,
}) => {
  const [fieldValues, setFieldValues] = useState({
    brokenPercentageInput: brokenPercentage,
    statusInput: status,
  });

  const [isValid, setIsValid] = useState({
    brokenPercentageInput: true,
  });

  const [pushNoti, setPushNoti] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pushNotier, setPushNotier] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    setFieldValues({
      brokenPercentageInput: brokenPercentage,
      statusInput: status,
    });
  }, [brokenPercentage, status, isPopup]);

  const handleReset = () => {
    setFieldValues({
      brokenPercentageInput: brokenPercentage,
      statusInput: status,
    });
  };

  const onEditHandler = (e) => {
    e.preventDefault();
    if (fieldValues.brokenPercentageInput.length === 0) {
      setIsValid((prev) => ({ ...prev, brokenPercentageInput: false }));
    }
    if (fieldValues.brokenPercentageInput.length > 0) {
      setLoading(true);

      const patchURL = moduleIdURL("masters/item-type", id);
      requests({
        method: "patch",
        url: patchURL,
        data: {
          broken_percentage: fieldValues.brokenPercentageInput,
          is_active: fieldValues.statusInput,
        },
      }).then((res) => {
        setIsValid({ brokenPercentageInput: true });
        if (res.error) {
         
          setError(res.data[0].message[0]);
         
          setPushNotier(true);
        } else {
          getFn(res);
          setError("");
          setPushNoti(true);
        }
      });
    }
  };
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  return (
    <div style={classes.container}>
      <form style={classes.form} onSubmit={onEditHandler}>
        <div style={classes.formGroup}>
          <TextField
            type="number"
            style={classes.textField}
            onFocus={StopScroll}
            variant="outlined"
            label="Broken Percentage *"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            onKeyDown={(e) => {
              // evt.key === "." && evt.preventDefault();

              e.key === "e" && e.preventDefault();

              e.key === "E" && e.preventDefault();
              e.key === "-" && e.preventDefault();
              e.keyCode === 38 && e.preventDefault();
              e.keyCode === 40 && e.preventDefault();

              // if (e.key !== "Backspace") {
              //   if (fieldValues.brokenPercentageInput.includes(".")) {
              //     if (
              //       fieldValues.brokenPercentageInput.split(".")[1].length >= 2
              //     ) {
              //       var num = parseFloat(fieldValues.brokenPercentageInput);
              //       var cleanNum = num.toFixed(2);
              //       fieldValues.brokenPercentageInput = cleanNum;
              //       e.preventDefault();
              //     }
              //   }
              // }
            }}
            value={fieldValues.brokenPercentageInput}
            onChange={({ target }) => {
              if (target.length !== 0) {
                setIsValid((prev) => ({
                  ...prev,
                  brokenPercentageInput: true,
                }));
              }
              if (target.value <= 100) {
                setFieldValues((prev) => ({
                  ...prev,
                  brokenPercentageInput: target.value,
                }));
              }
            }}
            error={!isValid.brokenPercentageInput}
            helperText={
              isValid.brokenPercentageInput ? "" : "Enter Broken Percentage"
            }
          />
        </div>
        <div style={classes.formActions}>
          <FormControlLabel
            control={
              <Switch
                checked={fieldValues.statusInput}
                style={{ color: "rgb(241 154 48)" }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setFieldValues((prev) => ({
                      ...prev,
                      statusInput: true,
                    }));
                  } else {
                    setFieldValues((prev) => ({
                      ...prev,
                      statusInput: false,
                    }));
                  }
                }}
              />
            }
            label={fieldValues.statusInput ? "Active" : "Inactive"}
          />
          <div>
            <Button
              onClick={handleReset}
              color="primary"
              style={{
                fontSize: "14px",
                textTransform: "capitalize",
                marginRight: "20px",
              }}
            >
              Reset to default
            </Button>
            <Button
              type="submit"
              variant="contained"
              style={{
                backgroundColor: "rgb(241 154 48)",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              update
            </Button>
          </div>
        </div>
      </form>
      {loading ? (
        <Backdrop
          style={{ zIndex: 1, color: "#fff", position: "absolute" }}
          open={loading}
        >
          <StyledCircularProgress color="rgb(30, 53, 89)" />
        </Backdrop>
      ) : (
        ""
      )}

      <Snackbar
        open={pushNoti}
        style={{}}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        severity="success"
        autoHideDuration={2000}
        onClose={() => {
          setPushNoti(false);
          setLoading(false);

          closePopup();
        }}
      >
        <Alert style={{ backgroundColor: "rgb(241 154 48)" }}>
          Changes have been saved!
        </Alert>
        {/* message="Changes have been saved!" */}
      </Snackbar>
      <Snackbar
        open={pushNotier}
        style={{}}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        severity="error"
        autoHideDuration={5000}
        onClose={() => {
          // setOpenPopup(false);
          setPushNotier(false);
          setLoading(false);
          setError("");
          // closePopup();
        }}
      >
        <Alert severity="error">{error}</Alert>
        {/* message="Changes have been saved!" */}
      </Snackbar>
    </div>
  );
};

export default EditForm;
